import * as _ from 'lodash';
import { Component, OnInit, Input, ViewChild, ElementRef, OnDestroy, SimpleChanges, inject, DestroyRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { GoogleMapsAutocompleteService } from 'app/google-maps-autocomplete/services/google-maps-autocomplete.service';

@Component({
  selector: 'app-campaign-event-venue',
  templateUrl: './campaign-event-venue.component.html',
  styleUrls: ['./campaign-event-venue.component.scss']
})
export class CampaignEventVenueComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  @ViewChild('field', {static: true}) field: ElementRef;
  @Input() formGroupCampaignTypeData: UntypedFormGroup = null;

  public eventVenue: UntypedFormGroup = null;
  public addressControl: UntypedFormControl = null;
  public address: string = null;

  constructor(
    public googleMapsAutocompleteService: GoogleMapsAutocompleteService
  ) { }

  ngOnInit(): void {
    this.eventVenue = this.formGroupCampaignTypeData.get('eventVenue') as UntypedFormGroup;
    this.addressControl = this.eventVenue.get('address') as UntypedFormControl;
  }

  ngOnChanges(changes: SimpleChanges) {
    const selected = _.get(changes, 'formGroupCampaignTypeData.currentValue', this.formGroupCampaignTypeData);

    this.eventVenue = selected.get('eventVenue') as UntypedFormGroup;
    const address = this.eventVenue.get('address');
    const addressText = this.googleMapsAutocompleteService.getAddressText(address.value);

    this.address = addressText;
  }
}
